module.exports = __webpack_public_path__ + "img/metaDatab&w.1a90d268.png";